import { AbsgArrayHelper, LogService } from '@absg/angular-common';
import { ActivityType, ActivityTypeODataApi, TransactionType, TransactionTypeODataApi } from '@absg/api-inventory';
import { BaseService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CommonDataService extends BaseService {
  transactionTypesMap = new Map<number, TransactionType>();
  activityTypesMap = new Map<number, ActivityType>();

  constructor(
    loggingService: LogService,
    private transactionTypeODataApi: TransactionTypeODataApi,
    private activityTypeODataApi: ActivityTypeODataApi,
  ) {
    super(loggingService);
  }

  getTransactionTypes(): Observable<TransactionType[]> {
    return this.transactionTypeODataApi.getTransactionTypesOData()
      .pipe(
        take(1),
        map((types) => {
          const newMap = new Map<number, TransactionType>();
          AbsgArrayHelper.forEach(types?.value, (type) => newMap.set(type.transactionTypeId, type));
          this.transactionTypesMap = newMap;
          return types?.value;
        }),
        catchError((error) => {
          this.handleError(error);
          return of(null);
        }),
      );
  }

  getActivityTypes(): Observable<ActivityType[]> {
    return this.activityTypeODataApi.getActivityTypesOData()
      .pipe(
        take(1),
        map((types) => {
          const newMap = new Map<number, ActivityType>();
          AbsgArrayHelper.forEach(types?.value, (type) => newMap.set(type.activityTypeId, type));
          this.activityTypesMap = newMap;
          return types?.value;
        }),
        catchError((error) => {
          this.handleError(error);
          return of(null);
        }),
      );
  }

  getTransactionTypeById(id: number): TransactionType {
    return this.transactionTypesMap.get(id);
  }

  getActivityTypeById(id: number): ActivityType {
    return this.activityTypesMap.get(id);
  }

  getActivityTypesByIds(ids: number[]): ActivityType[] {
    const result: ActivityType[] = [];
    AbsgArrayHelper.forEach(ids, id => {
      if (this.activityTypesMap.has(id)) {
        result.push(this.activityTypesMap.get(id));
      }
    });
    return result;
  }
}
